// Module
var code = "<go-media-player id=\"{{$ctrl.playerId}}\" class=\"audio-description\" playlist-item=\"$ctrl.playlistItem\" options=\"$ctrl.options\"></go-media-player>";
// Exports
module.exports = code;